import { Fragment } from 'react'
import PropTypes from 'prop-types'

import CardList from './widgets/CardList'


ServicesView.propTypes = {
  school: PropTypes.object.isRequired,
}

export default function ServicesView({ school }) {
  const addons = [
    ...school.private_lessons,
    ...school.leisure_programs,
    ...school.work_programs,
  ]

  return (
    <Fragment>
      <CardList data={school.courses} />
      <CardList data={addons} />
      <CardList data={school.accommodations} />
      <CardList data={school.transfers} />
    </Fragment>
  )
}
